/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getActPage = createAsyncThunk(
  'LudoFamilyCreate/getActPage',
  async (p: any, store: any) => {
    const resp = await http.post('/gamestore/ludo/family_act_page', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const actCreate = createAsyncThunk(
  'LudoFamilyCreate/family_act_create',
  async (p: any, store: any) => {
    const resp = await http.post('/gamestore/ludo/family_act_create', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getRecList = createAsyncThunk(
  'LudoFamilyCreate/family_act_rec_list',
  async (p: any, store: any) => {
    const resp = await http.post('/gamestore/ludo/family_act_rec_list', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const joinFamily = createAsyncThunk(
  'LudoFamilyCreate/join',
  async (p: any, store: any) => {
    const resp = await http.post('/live/family/join', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

const initialState: {
  err_msg: string
  date: string
  stage_one_date: string
  stage_two_date: string
  family_status: number
  stage_two: boolean
  rank_info: Array<any>
  rank_info_two: Array<any>
  my_rank_info: any
  my_rank_info_two: any
  missions: Array<any>
  recList: Array<any>
  score: number
} = {
  err_msg: '',
  date: '···',
  stage_one_date: '···',
  stage_two_date: '···',
  family_status: 0,
  stage_two: false,
  rank_info: [],
  my_rank_info: {},
  my_rank_info_two: {},
  rank_info_two: [
    // {
    //   rank: 1,
    //   score: 20000,
    //   name: 'RockAndRoll',
    //   image:
    //     'http://me-media-gateway.srv.test.ixiaochuan.cn/account/view/id/2283/sz/src',
    //   family_id: 22,
    // },
    // {
    //   rank: 2,
    //   score: 2350,
    //   name: 'RockAndRoll2',
    //   image:
    //     'http://me-media-gateway.srv.test.ixiaochuan.cn/account/view/id/2283/sz/src',
    //   family_id: 22,
    // },
    // {
    //   rank: 3,
    //   score: 20,
    //   name: 'RockAndRoll3',
    //   image:
    //     'http://me-media-gateway.srv.test.ixiaochuan.cn/account/view/id/2283/sz/src',
    //   family_id: 22,
    // },
  ],
  missions: [],
  recList: [],
  score: 0,
}

export const LudoFamilyCreateSlice = createSlice({
  name: 'LudoFamilyCreate',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getActPage.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state, data)
      })
      .addCase(getRecList.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state, {date: data.date, recList: data.rank_info})
      })
  },
})

export default LudoFamilyCreateSlice.reducer
